// Work.js
import React from "react";

export default function Work() {
  return (
    <section className="section alt">
      <div className="container">
        <h1 className="section-title">Selected Work</h1>
        <p className="section-sub">
          Explore how MYAC helps companies build, scale, and innovate with technology.
        </p>

        <div className="grid-3 cards">
          <div className="card card-body">
            <img src="/assets/fintech-card.png" alt="Fintech" className="case-img" />
            <h3>Fintech</h3>
            <p>Driving innovation in digital banking platforms.</p>
            <a href="#" className="link">Read case →</a>
          </div>
          <div className="card card-body">
            <img src="/assets/iot-card.png" alt="IoT" className="case-img" />
            <h3>IoT Solutions</h3>
            <p>Connected devices and predictive maintenance.</p>
            <a href="#" className="link">Read case →</a>
          </div>
          <div className="card card-body">
            <img src="/assets/ai-card.png" alt="AI" className="case-img" />
            <h3>AI Solutions</h3>
            <p>Unlocking insights with advanced ML models.</p>
            <a href="#" className="link">Read case →</a>
          </div>
        </div>
      </div>
    </section>
  );
}
